import styled from "styled-components";

export const SponsorPageStyle = styled.div`
  /* Remove default caret on dropdown-toggle to use custom icon only */
  .dropdown-toggle::after {
    display: none !important;
  }
  .configurationCardWidth {
    width: 89vh !important;
  }

  .dropdown {
    font-family: thin-pro, sans-serif;
  }
  .dropDown-custom {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .date-div {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .dropdown-menu.show {
    width: -webkit-fill-available;
  }
  .dropdown-item:hover,
  .dropdown-item:focus {
    /* color: var(--bs-dropdown-link-hover-color); */
    color: white;
    /* background-color: var(--bs-dropdown-link-hover-bg); */
    background-color: #ed9e44;
    cursor: pointer;
  }
  .configurationCard {
    box-shadow: 0 0 15px rgba(247, 148, 29, 0.3);
    transition: box-shadow 0.3s ease;
    border-radius: 8px;
    border: 1px solid white;
    padding: 2vh 3.5vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 80vh;
    margin-bottom: 5vh;
    margin-top: 5vh;
    overflow-wrap: anywhere;
    justify-content: space-between;
    align-self: center;
    :hover {
      box-shadow: 0 15px 24px rgba(247, 148, 29, 0.3);
    }
  }

  .greyed-out {
    color: #b0b0b0 !important;
    opacity: 0.6;
    pointer-events: none;
  }
  .green .input-range__track--active {
    background-color: green;
  }

  .green .input-range__slider {
    background-color: green;
    border-color: green;
  }

  .yellow .input-range__track--active {
    background-color: yellow;
  }

  .yellow .input-range__slider {
    background-color: yellow;
    border-color: yellow;
  }

  .red .input-range__track--active {
    background-color: red;
  }

  .red .input-range__slider {
    background-color: red;
    border-color: red;
  }

  .form-button {
    width: 26vh;
    background-color: rgb(242, 136, 9);
    border-color: white;
    margin-top: 10px;
    color: white;
    font-family: medium-pro, sans-serif;
    -webkit-box-pack: center;
    justify-content: center;
    font-size: 0.7rem;
    padding: 10px 0px;
    align-self: center;
  }

  h5 {
    align-self: start;
    margin-top: 25px;
    margin-bottom: 20px;
    font-family: "Decimal A", "Decimal B", Avenir, "Helvetica Neue", Helvetica,
      "Arial Narrow", sans-serif;
  }

  .form-check {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 10px;
  }

  .form-check-label {
    margin-left: 10px;
    font-family: thin-pro, sans-serif;
  }

  .form-check-input:checked {
    background-color: #f28809;
    border-color: #f28809;
    margin-top: 0 !important;
  }

  .input-field {
    height: 4vh;
    margin-bottom: 5px;
    font-family: thin-pro, sans-serif;
    :focus {
      border-color: white;
      box-shadow: 0 0 5px #f7951d;
    }
  }

  .trigger-div {
    display: flex;
    justify-content: space-between;
  }

  .row-div {
    border: 20px solid white;
  }

  .field-div {
    display: flex;
    justify-content: end;
    margin-right: 5px;
    font-family: medium-pro, sans-serif;
  }

  .field-div-logo {
    display: flex;
    justify-content: end;
    margin-right: 5px;
    margin-bottom: 18px;
    font-family: medium-pro, sans-serif;
  }

  .react-time-picker__wrapper {
    border: thin solid #dee2e6;
    border-radius: 5px;
  }

  .react-time-picker__button:enabled:hover .react-time-picker__button__icon,
  .react-time-picker__button:enabled:focus .react-time-picker__button__icon {
    stroke: #f28809;
  }

  .time-div {
    display: flex;
  }

  .table-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-top: 10px;
    font-family: medium-pro, sans-serif;
  }

  .table-item2 {
    font-family: thin-pro, sans-serif;
  }
  .table-div2 {
    padding: 20px;
    width: 95%;
    display: flex;
    overflow-y: auto;
    margin-bottom: 20px;
    flex-wrap: wrap;
    justify-content: center;
    align-self: center;
  }

  .table-head {
    position: sticky;
    top: -20px;
    background: white;
  }

  .delete-icon {
    font-size: 1.2rem;
    color: #dd3e3e;
  }

  .edit-icon {
    font-size: 1.2rem;
    color: rgb(62, 221, 81);
    margin-right: 10px;
  }

  .disable-icon {
    pointer-events: none;
    color: #bcb7b7;
  }

  .view-icon {
    font-size: 1.2rem;
    color: #f28809;
    margin-right: 10px;
  }

  .disable-view-icon {
    pointer-events: none;
    color: #bcb7b7;
  }
  .table-loading {
    text-align: center;
    font-size: 1rem;
  }
  .radio-div2 {
    align-self: center;
    display: flex;
    font-family: thin-pro, sans-serif;
    justify-content: start;
    align-items: center;
  }  /* Reports dropdown container - prevent layout shift */
    

  /* Custom dropdown styles */
  .custom-dropdown-menu {
    margin: 0;
    padding: 4px 0;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    z-index: 1000;
    min-width: 160px;
    width: auto;
    max-width: 250px;
    max-height: 200px;
    overflow-y: auto;
    white-space: nowrap;
    /* Ensure dropdown doesn't affect layout */
    box-sizing: border-box;
  }
  
  .custom-dropdown-item {
    padding: 6px 12px;
    white-space: nowrap;
    font-family: thin-pro, sans-serif;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .custom-dropdown-item:hover,
  .custom-dropdown-item:focus {
    background-color: #ed9e44 !important;
    color: #fff !important;
    cursor: pointer;
  }
`;

export const AnalyticsPageStyle = styled.div`
  /* Remove default dropdown caret for Reports dropdown */
   .custom-dropdown-menu {
    margin: 0;
    padding: 4px 0;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    z-index: 1000;
    min-width: 160px;
    width: auto;
    max-width: 250px;
    max-height: 200px;
    overflow-y: auto;
    white-space: nowrap;
    /* Ensure dropdown doesn't affect layout */
    box-sizing: border-box;
  }
  
  .custom-dropdown-item {
    padding: 6px 12px;
    white-space: nowrap;
    font-family: thin-pro, sans-serif;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .custom-dropdown-item:hover,
  .custom-dropdown-item:focus {
    background-color: #ed9e44 !important;
    color: #fff !important;
    cursor: pointer;
  }
  // .dropdown-toggle::after {
  //   display: none !important;
  //   content: none !important;
  // }

  // /* bump dropdown menu down slightly under the toggle */
  // .dropdown-menu {
  //   margin-top: 0rem !important;
  // }

  .form-button {
    width: 24vh;
    background-color: #f28809;
    border-color: white;
    margin-top: 50px;
    color: white;
    font-family: medium-pro, sans-serif;
    justify-content: center;
    font-size: 1rem;
    padding: 10px 0;
    align-self: center;
  }

  .form-button1 {
    width: 19vh;
    background-color: #f28809;
    border-color: white;
    margin-top: 50px;
    color: white;
    font-family: medium-pro, sans-serif;
    justify-content: center;
    font-size: 1rem;
    padding: 10px 0;
    align-self: center;
    margin-left: 0;
    margin-right: 0;
  }
  .btn-div {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 50px;
    margin-bottom: 40px;
    position: relative;
    min-height: 60px;
    width: 100%;
    padding-left: 10vw;
  }
  .btn-div1 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 60px;
    width: 100%;
  }

  .main {
    padding-top: 20px; /* add some padding */
    padding-bottom: 20px; /* add some padding */
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .main2 {
    padding-top: 20px; /* add some padding */
    padding-bottom: 20px; /* add some padding */
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }

  .reports-field {
    background-color: #f28809;
    color: white;
    font-family: medium-pro, sans-serif;
    font-size: 1rem;
    width: 12vh;
  }
  .reports-field .reports-option {
    background-color: white;
    color: black;
  }
  /* Style report dropdown options hover/focus like customer dropdown items */
  .reports-field option:hover,
  .reports-field option:focus {
    background-color: #ed9e44;
    color: white;
  }
  .reports-field option:checked {
    background-color: #ed9e44;
    color: white;
  }
  /* Highlight dropdown items in reports dropdown */
  .dropdown-menu .dropdown-item:hover,
  .dropdown-menu .dropdown-item:focus {
    background-color: #ed9e44 !important;
    color: white !important;
  }

  /* Ensure custom dropdown items in Reports also have orange hover */
  .custom-dropdown-item:hover,
  .custom-dropdown-item:focus {
    background-color: #ed9e44 !important;
    color: #fff !important;
    cursor: pointer;
  }
`;

export const SponsorshipCardByDurationStyle = styled.div`
  .mainDivStyle {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    min-height: 140px;
    padding: 18px 12px;
    background: #faf9f7;
    width: 23vh;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  .headingStyle {
    font-weight: 600;
    font-size: 17px;
    margin-bottom: 8px;
    text-align: center;
  }

  .borderStyle {
    border: 2px solid #f28809;
    border-radius: 8px;
    padding: 12px 20px;
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    font-size: 15px;
    background: #fff;
    flex-direction: column;
  }
`;

export const DownloadSponsorReportPageStyle = styled.div`
  .configurationCard {
    box-shadow: 0 0 15px rgba(247, 148, 29, 0.3);
    transition: box-shadow 0.3s ease;
    border-radius: 8px;
    border: 1px solid white;
    padding: 2vh 3.5vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 100vh;
    margin-bottom: 5vh;
    margin-top: 5vh;
    overflow-wrap: anywhere;
    justify-content: space-between;
    align-self: center;
    :hover {
      box-shadow: 0 15px 24px rgba(247, 148, 29, 0.3);
    }
  }

  .form-button {
    width: 25vh;
    background-color: rgb(242, 136, 9);
    border-color: white;
    margin-top: 10px;
    color: white;
    font-family: medium-pro, sans-serif;
    -webkit-box-pack: center;
    justify-content: center;
    font-size: 1rem;
    padding: 10px 0px;
    align-self: center;
  }

  .btn-div {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 10px;
    width: 100%;
    align-items: baseline;
  }

  .input-field {
    height: 4vh;
    margin-bottom: 5px;
    width: 80% !important;
    font-family: thin-pro, sans-serif;
    :focus {
      border-color: white;
      box-shadow: 0 0 5px #f7951d;
    }
  }
  .headingStyle {
    display: flex;
    gap: 10px;
    align-items: baseline;
    margin-bottom: 10px;
  }
  .headingStyle2 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    gap: 5px;
  }

  .headingStyle3 {
    width: 50%;
    display: flex;
    justify-content: flex-start;
  }
  .heading_text {
    font-weight: bold;
  }

  .radio-div2 {
    align-self: center;
    display: flex;
    width: 500px;
    font-family: thin-pro, sans-serif;
    margin-bottom: 30px;
  }

  .form-check2 {
    display: flex;
    justify-content: flex-start;
    align-items: unset;
    margin-right: 50px;
  }

  .form-check-input:checked {
    background-color: #f28809;
    border-color: #f28809;
  }
  .form-check-label {
    margin-left: 15px;
    font-family: thin-pro, sans-serif;
  }

  .input-div {
    width: 70%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;
